import { render, staticRenderFns } from "./myFlow.vue?vue&type=template&id=56552a0c&scoped=true&"
import script from "./myFlow.vue?vue&type=script&lang=js&"
export * from "./myFlow.vue?vue&type=script&lang=js&"
import style0 from "./myFlow.vue?vue&type=style&index=0&id=56552a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56552a0c",
  null
  
)

export default component.exports